var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
const PlainInput = (props) => {
    const { autoComplete, className, input, meta, wrapOnBlur, wrapOnChange } = props, others = __rest(props, ["autoComplete", "className", "input", "meta", "wrapOnBlur", "wrapOnChange"]);
    const onChange = useCallback((e) => {
        if (wrapOnChange) {
            wrapOnChange(e);
        }
        input.onChange(e);
    }, [input, wrapOnChange]);
    const onBlur = useCallback((e) => {
        if (wrapOnBlur) {
            wrapOnBlur(e);
        }
        input.onBlur(e);
    }, [input, wrapOnBlur]);
    const disableEnter = useCallback((e) => {
        const keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
        return true;
    }, []);
    const warnClass = useMemo(() => (meta.touched && meta.error ? 'is-warning' : ''), [meta.touched, meta.error]);
    return (_jsx("input", Object.assign({}, input, { autoComplete: autoComplete, className: `${className} ${warnClass}`, onBlur: onBlur, onChange: onChange, onKeyPress: disableEnter }, others)));
};
PlainInput.propTypes = {
    autoComplete: propStr(),
    className: propStr().isRequired,
    id: propStr(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
    wrapOnBlur: propFunc(),
    wrapOnChange: propFunc(),
};
PlainInput.defaultProps = {
    autoComplete: 'off',
    id: undefined,
    wrapOnBlur: undefined,
    wrapOnChange: undefined,
};
export default PlainInput;
